import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n from './index';

interface AdminI18nProviderProps {
  children: ReactNode;
}

// Отдельное имя от frontend/ I18nProvider (разные бандлы/origin) — осознанно
// не переиспользуют код (PARA-106 §7).
export function AdminI18nProvider({ children }: AdminI18nProviderProps): JSX.Element {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
